/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RestrictionMixinNotSetPasswordParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('not-set')],
]);
export class RestrictionMixinNotSetPassword extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RestrictionMixinNotSetPasswordParser.decode(input).map(res => new RestrictionMixinNotSetPassword(res));
    }
    static unsafeDecode(input) {
        return RestrictionMixinNotSetPassword.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RestrictionMixinNotSetPasswordParser.encode(data);
    }
    static schema() {
        return RestrictionMixinNotSetPasswordParser.schema();
    }
}
